
(function(){
    "use strict";
    
    angular.module('irricrops')
    .controller("catastroCtrl", ["$scope","Config","$timeout", "resumen",
    function( $scope, Config, $timeout,resumen){
        var vm = this;
        
        vm.header = [

            //variables principales
            {
                label: "Detalles",
                active: true,
                items: [
                    {
                        label: "Sup",
                        var: "ha",
                        width: 'mini'
                    },
                    {
                        label: "Variedad",
                        var: "variedad",
                        get:"resumen.calidades.variedad_nombre",
                        width: 4
                    },
                    {
                        label: "Calidad",
                        var: "calidad",
                        get:"resumen.calidades.calidad_nombre",
                        width: 4
                    },
                    {
                        label: "m3 lineas",
                        var: ""
                    },
                    {
                        label: "Plantas/ha",
                        var: ""
                    },
                    {
                        label: "Plantas totales",
                        var: "",
                        width: 4
                    },
                    {
                        label: "Entre Hil",
                        var: ""
                    },
                    {
                        label: "Sobre Hil.",
                        var: ""
                    },
                    {
                        label: "Clon",
                        var: ""
                    },
                    {
                        label: "PortaInjerto",
                        var: ""
                    },
                ]
            },

            //variables por temporada
            {
                label: "KG/HA",
                var:"foo",
                items: [
                    {
                        label: "2019-2020",
                        var: "2019-2020"
                    },
                    {
                        label: "2020-2021",
                        var: "2020-2021"
                    },
                    {
                        label: "2021-2022",
                        var: "2021-2022"
                    }
                ]
            },
            {
                label: "KG/cuartel",
                var:"foo",
                items: [
                    {
                        label: "2019-2020",
                        var: "2019-2020"
                    },
                    {
                        label: "2020-2021",
                        var: "2020-2021"
                    },
                    {
                        label: "2021-2022",
                        var: "2021-2022"
                    }
                ]
            },
            {
                label: "Peso Poda",
                var:"foo",
                items: [
                    {
                        label: "2019-2020",
                        var: "2019-2020"
                    },
                    {
                        label: "2020-2021",
                        var: "2020-2021"
                    },
                    {
                        label: "2021-2022",
                        var: "2021-2022"
                    }
                ]
            },
        ];
        vm.tableData = [
            {
                label: "sector 1",
                foo: 1,
                bar: 1,
                baz: 1,
                temporadas: {
                    foo:{
                        '2019-2020': 19,
                        '2020-2021': 20,
                        '2021-2022': 21,
                    },
                    bar:{
                        '2019-2020': 19,
                        '2020-2021': 20,
                        '2021-2022': 21,
                    },
                    baz:{
                        '2019-2020': 19,
                        '2020-2021': 20,
                        '2021-2022': 21,
                    },
                }
            }
        ];


        vm.tableData = _.flatMap(resumen.data.vinedo.equipos, function (e){
            return _.map(e.sector_riego, function (s) {
                var sector = _.cloneDeep(s);
                sector.equipo = e;
                sector.label = s.nombre;

                //header[0], variables principales
                _.forEach(vm.header[0].items, function(h){
                    if(h.get){
                        sector[h.var] = _.get(sector, h.get);
                    }
                })

                return sector;
            });
        });


    }]);
})();
